@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.dual-action-group {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.direct-action-name {
  margin-top: -5px;
}

.direct-action-target {
  .truncate();
  max-width: 100%;
  color: @print-document--direct-action-target--text-color;
  padding-top: 2px;
  font-size: 12px;
}

.direct-action-wrapper {
  width: 100%;
  max-width: calc(100% - 32px);
}

.modal-action-wrapper {
  width: 32px;
  min-width: 32px;
}

.print-action-button {
  cursor: pointer;
  min-width: 32px;
  height: 100%;
  &:hover {
    background-color: @print-document--print-action-button--hover--background-color;
  }
}

.print-action-group {
  padding: 0;
  &:hover {
    background-color: @print-document--print-action-group--hover--background-color;
  }
}

.print-dialog-action {
  display: flex;
  place-content: center center;
  flex-wrap: wrap;
  > svg {
    width: 16px;
    height: 16px;
    color: @print-document--print-dialog-action--fill-color;
  }
}

.print-direct-action {
  width: 100%;
  text-align: left;
  border-right: 1px solid @print-document--print-direct-action--border-color;
  padding: 10px 10px 5px;
}
